import { IUrlGrid } from '@pages/generics/grid/state-handlers/handler-types';
import { IGridDataEntry } from '@uipath/angular/components/ui-grid';

import isEqual from 'lodash-es/isEqual';
import {
    distinctUntilChanged,
    filter,
    map,
    takeUntil,
    tap,
} from 'rxjs/operators';

import { GridStateAdapter } from './grid-adapter';
import { StorageAdapter } from './storage-adapter';
import { UrlAdapter } from './url-adapter';

const distinctDeep = <T>(previous: T, current: T) => isEqual(previous, current);

export function urlStateHandler<
    TEntity extends IGridDataEntry,
    >(gridApi: IUrlGrid<TEntity>) {

    const grid = new GridStateAdapter(gridApi);
    const url = new UrlAdapter(gridApi);
    const storage = new StorageAdapter(gridApi);

    let replaceURL = true;
    // ActivatedRoute is overwritten for each component
    // we need to access the QPs via the router in base classes
    // https://github.com/angular/angular/issues/9662

    gridApi.router.routerState.root.queryParamMap
        .pipe(
            tap(() => replaceURL = false),
            distinctUntilChanged(distinctDeep),
            map(params => url.extractParams(params)),
            filter(({ hasAny }) => hasAny || storage.isStateStored()),
            map(({ params, hasAny }) => url.computeParams(params, hasAny ? null : storage.getState())),
            takeUntil(gridApi.destroyed$),
        ).subscribe(params => {
            grid.setState(params);
            gridApi.nextQuery();

            storage.storeState(params);
            url.storeState(replaceURL);
        });

    gridApi.stateChange$.pipe(
        takeUntil(gridApi.destroyed$),
    ).subscribe(() =>
        url.storeState(replaceURL),
    );
}
